<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <div class="btn">
            <el-button type="primary" @click="addOrUpdateHandle()">新增</el-button>
          </div>
        </el-form-item>
      </el-form>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
        border
    >
      <el-table-column prop="accountType" label="账户类型" header-align="center" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <span v-if="scope.row.accountType == 'LOAN'"> 小贷 </span>
            <span v-else-if="scope.row.accountType == 'FUND'"> 资方 </span>
          </template>
      </el-table-column>
      <el-table-column prop="companyName" label="公司名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="appId" label="商户标识" header-align="center" align="center"></el-table-column>
      <el-table-column prop="merNo" label="商户代码" header-align="center" align="center"></el-table-column>
      <el-table-column prop="userId" label="系统用户编号" header-align="center" align="center"></el-table-column>
      <el-table-column
        label="关联小贷账户"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.parentId == 0">无</span>
          <span v-else>
            {{ getParentInfo(scope.row.parentId) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="keyStorePath" label="私钥证书名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="keyStorePassword" label="私钥证书密码" header-align="center" align="center"></el-table-column>
      <el-table-column prop="publicKeyStorePath" label="公钥证书名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="virtualAccount" label="虚拟账号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="payType" label="支付方式" header-align="center" align="center">
        <template slot-scope="scope">
          {{ scope.row.payType== '0' ? '资方发起' : '小贷发起' }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="开户时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="operate" label="操作" header-align="center" align="center"  width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id,'update')">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
      
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './ttfopenaccount-add-or-update.vue'
export default {
  mixins: [mixinViewModule],
  components:{
    AddOrUpdate
  },
  data() {
    return {
      
      mixinViewModuleOptions: {
        getDataListURL: `/ttf/account/page`,
        getDataListIsPage: true,
        // multilist:true,

      },
      loanMap: {},
      showPwd: {},
    } 
  },
  created(){
    this.loadLoanListForMap()
  },
  methods:{
    // 加载所有小贷账户用于表格展示
    loadLoanListForMap() {
      this.$http
        .get('/ttf/account/page', { params: { parentId: '0', page: 1, limit: 1000 } })
        .then(({ data: res }) => {
          if (res.code === 0) {
            res.data.list.forEach(item => {
              this.$set(this.loanMap, item.id, item)
            })
          }
        })
    },
    togglePwd(id) {
      this.$set(this.showPwd, id, true)
    },
    hidePwd(id) {
      this.$set(this.showPwd, id, false)
    },
    getParentInfo(id) {
      const parent = this.loanMap[id];
      if (!parent) return '— ()';
      return `${parent.companyName || '—'} (${parent.userId || ''})`;
    }
  }
}
</script>
<style scoped lang="scss">
</style>